<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="excmdevicebrand_brandTitle"
        class="form-control-label">{{$t('views.excmdevicebrand.form.title')}}:</label>
      <input
        id="excmdevicebrand_brandTitle"
        v-model="item.brandTitle"
        :class="['form-control', isInvalid('brandTitle') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('brandTitle', $event.target.value)">
      <div
        v-if="isInvalid('brandTitle')"
        class="invalid-feedback">{{ violations.brandTitle }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">{{$t('buttons.submit')}}</button>
    <b-btn v-if="openedInModal" @click="closeModal()" variant="danger">{{$t('buttons.close')}}</b-btn>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    closeModal () {
      this.$store.state.modals.excmdevicebrand.form.close = 1
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
